export const SITE = {
  name: "Jaehan Loh",
  role: "Software Engineer",
  location: "Philadelphia, PA",
  /**
   * Split so the literal address never appears contiguously in the bundle.
   * Naive scrapers regex for `\S+@\S+`; this defeats that while keeping the
   * link clickable, which `name [at] domain` does not.
   */
  emailUser: "jaehanloh",
  emailDomain: "gmail.com",
  /**
   * The contact-panel note. This is the one place the page states intent, so
   * it says what is being looked for rather than what would be tolerated.
   */
  availabilityLong:
    "Currently a full-time developer and founder at Peng-O-Labs. Open to full-time software engineer roles.",
  headline: "I build systems that stay fast when the numbers get large.",
  intro:
    "Six years of full-stack work across enterprise and founder-led teams. Two years on Qualtrics' data visualization team shipping React, TypeScript and D3 to enterprise customers, and the last two building server-authoritative multiplayer systems in Unity against a 16.67 ms frame budget, with two titles shipped to Steam.",
  links: {
    github: "https://github.com/jaehan98/",
    linkedin: "https://www.linkedin.com/in/jaehan-loh/",
    resume: "/Jaehan_Loh_Resume.pdf",
  },
};

/** Reassembled at runtime, never stored whole. */
export const email = () => `${SITE.emailUser}@${SITE.emailDomain}`;
export const mailto = () => `mailto:${email()}`;

/** Load-bearing numbers. Every one is measured or shipped. */
export const PROOF: {
  value: string;
  label: string;
  note: string;
}[] = [
  {
    value: "2",
    label: "games shipped to Steam",
    note: "One in Early Access, one in public demo",
  },
  {
    value: "10,000+",
    label: "entities in one frame budget",
    note: "Plus towers, projectiles and effects. Dev-class hardware",
  },
  {
    value: "16.67",
    label: "ms frame budget",
    note: "Not negotiable. The system gets rebuilt, not the budget",
  },
  {
    value: "6",
    label: "years engineering",
    note: "Small team, enterprise, solo, now a two-person studio",
  },
];

export const NAV = [
  { id: "work", label: "Work" },
  { id: "experience", label: "Experience" },
  { id: "skills", label: "Skills" },
  { id: "contact", label: "Contact" },
];
